export default "__VITE_ASSET__FDXo1iyY__"